import get from 'transmute/get';
import { List } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { mapResolve } from 'reference-resolvers/utils';
import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import TeamSelect from 'ui-addon-teams/components/TeamSelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {
  teams: List(),
  isLoading: true
};
const atomToPromise = atom => {
  return new Promise((resolve, reject) => {
    const toPromise = mapResolve({
      loading() {},
      error(value) {
        // reason should be an Error object
        reject(get('reason', value));
        unwatch(atom, toPromise);
      },
      resolved(value) {
        if (value != null) {
          resolve(value);
          unwatch(atom, toPromise);
        }
      }
    });
    watch(atom, toPromise);
    toPromise(deref(atom));
  });
};
class TimelineFilterTeams extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.renderButtonContent = this.renderButtonContent.bind(this);
  }
  componentDidMount() {
    this.loadTeams();
  }
  loadTeams() {
    const promise = atomToPromise(this.props.resolvers.HIERARCHICAL_TEAM.all());
    promise.then(resp => {
      this.setState({
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        teams: resp.toList(),
        isLoading: false
      });
    }).catch(() => {
      this.setState({
        isLoading: false
      });
    });
  }
  renderButtonContent() {
    const {
      value
    } = this.props;
    if (!value || !value.size) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "timeline.filters.teams.noneSelected"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.filters.teams.selected",
      options: {
        count: value.size
      }
    });
  }
  render() {
    const {
      teams,
      isLoading
    } = this.state;
    if (!isLoading && !teams.size) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "timeline-filter-teams",
      children: /*#__PURE__*/_jsx(TeamSelect, {
        isLoading: isLoading,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "timeline.filters.teams.noneSelected"
        }),
        showTags: false,
        teams: teams,
        onChange: this.props.onChange,
        value: this.props.value,
        ButtonContent: this.renderButtonContent,
        minimumSearchCount: 0,
        open: this.props.isTeamFilterOpen,
        onOpenChange: this.props.handleTeamOpenChange
      })
    });
  }
}
TimelineFilterTeams.propTypes = {
  handleTeamOpenChange: PropTypes.func.isRequired,
  isTeamFilterOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  resolvers: PropTypes.object,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  value: PropTypes.instanceOf(List)
};
export const UnconnectedTimelineFilterTeams = TimelineFilterTeams;
const getResolvers = ConnectReferenceResolvers(resolvers => ({
  resolvers
}));
export default getResolvers(TimelineFilterTeams);